import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';

import { CampanhaCuponsFormComponent } from './campanha-cupons-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaCuponsFormComponent
    ],
    exports: [
        CampanhaCuponsFormComponent
    ]
})
export class CampanhaCuponsFormModule { }
